<template>
  <div id="basic-information">
    <div class="info-container">
      <i class="icon-clock"></i>
      <ul>
        <li v-html="content.opening_hours"></li>
      </ul>
    </div>
    <div class="info-container">
      <i class="icon-location"></i>
      <ul>
        <li v-html="content.address_1"></li>
        <li v-html="content.town_and_code"></li>
        <li v-html="content.info"></li>
        <li v-html="content.address_2"></li>
      </ul>
    </div>
    <div class="info-container">
      <i class="icon-phone"></i>
      <ul>
        <li v-html="content.fax"></li>
        <li v-html="content.phone_num"></li>
      </ul>
    </div>
    <div class="info-container">
      <i class="icon-email"></i>
      <ul>
        <li v-html="content.email"></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicInformation',
  props: {
    content: Object,
  },
};
</script>

<style scoped lang="scss">
  #basic-information {
    position: relative;
    padding: 25px;

    display: flex;
    flex-direction: column;

    font-family: Quicksand, sans-serif;
    font-weight: bold;
    font-size: 14px;
    color: white;

    @media (min-width: 768px) {
      width: 50%;
      left: 100px;
      font-size: 16px;
    }

    @media (min-width: 992px) {
      grid-area: basic;
      width: 100%; left: 0;
    }

    @media (min-width: 1200px) { font-size: 1.2em; }
  }

  .info-container {
    position: relative;
    display: flex;
    margin: 0 0 25px 0;

    ul, li { list-style-type: none; margin: 0; padding: 0 5px }

    i {
      width: 13px;

      @media (min-width: 1200px) { width: 25px; }
    }

    li { text-align: left; }
  }
</style>
